export const elementDisplayName = (name: string | null | undefined, fallback = ''): string =>
  name != null && name.trim().length > 0 ? name : fallback

const compareIds = (a: string, b: string): number => (a < b ? -1 : a > b ? 1 : 0)

export const compareByName = (aName: string, aId: string, bName: string, bId: string): number => {
  const byName = aName.trim().localeCompare(bName.trim(), undefined, { sensitivity: 'base', numeric: true })
  return byName !== 0 ? byName : compareIds(aId, bId)
}

export const sortByName = <T>(items: readonly T[], nameOf: (item: T) => string, idOf: (item: T) => string): T[] =>
  [...items].sort((a, b) => compareByName(nameOf(a), idOf(a), nameOf(b), idOf(b)))
